export interface ParallelogramProps {
  className?: string;
  color: string;
}

export const Parallelogram = ({ className, color }: ParallelogramProps) => {
  return (
    <svg className={className} width={40} height={138} viewBox="0 0 40 138" xmlns="http://www.w3.org/2000/svg">
      <path d={`M40 0L40 098L0 138L0 40L40 0`} fill={color} />
    </svg>
  );
};
